import React, {useEffect, useState} from "react";
import {useAuth} from "../../authprovider";
import {useLocation} from "react-router-dom";
import {faFilePdf, faSpinner} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const viewPdf =(blob)=>{
    let newBlob = new Blob([blob], {type:"application/pdf"})
    let objectURL = URL.createObjectURL(newBlob);
    window.open(objectURL,"_blank");
}

function DocumentListItem(props){

    const { buildings} = useAuth();
    const [downloading, setDownloading] = useState(false)


    const showDocument = ()=>{
        setDownloading(true)
        const suffix = "/document/download/"+props.id;

        buildings.download(suffix, response=>{
            const {success, error, content} = response;

            if(success===true){
                viewPdf(content)
            } else
                console.log(error);

            setDownloading(false);
        })

    }

    return (
        <div onClick={showDocument} className={"evacuationDoc d-flex justify-content-between"}>
            {props.value}
            {
                downloading ?
                    <FontAwesomeIcon className={"float-end fs-2 "}  icon={faSpinner} spin />
                    :
                    <FontAwesomeIcon className={"float-end fs-2 "}  icon={faFilePdf} />
            }
        </div>
    )
}

export default function EvacuationList(props){

    const {user, buildings} = useAuth();
    const location = useLocation();
    const building_id = location.hash ? location.hash.replace("#",'') : user.building;

    const [documents, setDocuments] = useState(undefined);

    useEffect(()=>{
        if(documents!== undefined)
            return;

        const suffix = building_id+'/document/evac';

        buildings.getDocuments(suffix, response=>{
            const {success, content} = response;

            if(success === true)
                setDocuments(content);
        })
    })

    return (
        <div className={"evacuationList"}>
            {
                documents && documents.map((doc)=>
                    <DocumentListItem key={doc.id} id={doc.id} value={doc.name} />
                )
            }

        </div>
    )
}